import { render, staticRenderFns } from "./FolderSendToGedWarningDialog.vue?vue&type=template&id=30fb16e6&scoped=true"
import script from "./FolderSendToGedWarningDialog.vue?vue&type=script&lang=js"
export * from "./FolderSendToGedWarningDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderSendToGedWarningDialog.vue?vue&type=style&index=0&id=30fb16e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb16e6",
  null
  
)

export default component.exports